import AddViewCombobox from "@/components/settings/homepage/customViews/AddViewCombobox";
import { Button } from "@/components/ui/button";
import CustomView from "@/domain/entities/customViews/CustomView";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type AddViewProps = {
    availableViews: CustomView[];
    handleAddViewToFavorites: (view: CustomView) => void;
};

const AddView = ({
    availableViews,
    handleAddViewToFavorites,
}: AddViewProps) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string>("");

    return (
        <div className="mt-2 flex items-center gap-2">
            <AddViewCombobox
                availableViews={availableViews}
                setValue={setValue}
                value={value}
            />
            <Button
                disabled={!value}
                onClick={() => {
                    const viewAdded = availableViews.find(
                        (view) => view.name === value,
                    );
                    if (viewAdded && viewAdded.id) {
                        handleAddViewToFavorites(viewAdded);
                    }
                }}
                variant="purpleGradient"
            >
                {t("settings.homepage.customViews.addView.button")}
            </Button>
        </div>
    );
};

export default AddView;
